var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoapOpera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Love-It-Break--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Love It Break Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.32 5.2a6.58 6.58 0 0 0 -10.45 -1.71c-0.21 0.19 -0.28 0.23 -0.31 0.32l-2.7 7.35a0.24 0.24 0 0 0 0 0.23 0.25 0.25 0 0 0 0.2 0.1h4.79a0.75 0.75 0 0 1 0.6 0.3 0.74 0.74 0 0 1 0.12 0.66l-2.43 8.65a0.27 0.27 0 0 0 0.11 0.29 0.26 0.26 0 0 0 0.31 0l8.21 -8.46a6.39 6.39 0 0 0 1.55 -7.73Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 13.31a0.29 0.29 0 0 0 0 -0.22 0.28 0.28 0 0 0 -0.2 -0.1H8.66A0.75 0.75 0 0 1 8 12l3 -8.4a0.25 0.25 0 0 0 0 -0.27 6.49 6.49 0 0 0 -5.51 -1.62A6.47 6.47 0 0 0 0.7 5.2a6.39 6.39 0 0 0 1.19 7.45s7.36 7.94 9 9.65a0.26 0.26 0 0 0 0.24 0.07 0.26 0.26 0 0 0 0.18 -0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoapOpera);
export default ForwardRef;